import styled, { css } from 'styled-components';
import { SPOTLIGHT_VISITOR_CONTENT_PADDING_VERTICAL_PX } from 'conversations-visitor-message-history/primary-message/components/messageDimensions';
import AttachmentCard from './AttachmentCard';
import { jsx as _jsx } from "react/jsx-runtime";
const inlinePadding = css(["padding-top:", "px;padding-bottom:", "px;padding-left:", ";padding-right:0;margin-top:", ";"], ({
  $fromVisitor
}) => $fromVisitor ? SPOTLIGHT_VISITOR_CONTENT_PADDING_VERTICAL_PX : 0, ({
  $fromVisitor
}) => $fromVisitor ? SPOTLIGHT_VISITOR_CONTENT_PADDING_VERTICAL_PX : 0, ({
  $fromVisitor,
  theme
}) => $fromVisitor ? theme.spotlight.spacing.md : theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.spacing.xs);

/* Replicates the real total inset an inline attachment gets from its
   ancestors, since a standalone (image-only) message has no SpacingWrapper
   or PrimaryMessageContentWrapper to provide any of it. Both senders land
   on the same spacing.lg (16px) total, just via different paths:
   - visitor: SpacingWrapper's own messageHorizontalPadding is already 16px
     (SPOTLIGHT_STANDALONE_PADDING_PX — deliberately larger than agent's, to
     keep a consistent 24px gap to the widget edge around the bubble).
   - agent: SpacingWrapper's 8px (SPOTLIGHT_SPACING_PADDING_PX) plus the 8px
     padding on PrimaryMessageContentWrapper (SPOTLIGHT_WRAPPER_PADDING_PX). */
const standalonePadding = css(["padding-top:", ";padding-bottom:", ";padding-right:", ";padding-left:", ";"], ({
  theme
}) => theme.spotlight.spacing.xs, ({
  theme
}) => theme.spotlight.spacing.xs, ({
  theme
}) => theme.spotlight.spacing.lg, ({
  theme
}) => theme.spotlight.spacing.lg);
const AttachmentCardWrapper = styled.div.withConfig({
  displayName: "SpotlightAttachments__AttachmentCardWrapper"
})(["", " ", ""], ({
  $isInline
}) => $isInline ? inlinePadding : standalonePadding, ({
  $fromVisitor
}) => $fromVisitor && 'display: flex; justify-content: flex-end;');
const SpotlightAttachments = ({
  fileAttachments,
  fromVisitor,
  isInline = false
}) => {
  if (!fileAttachments.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(AttachmentCardWrapper, {
    $fromVisitor: fromVisitor,
    $isInline: isInline,
    children: /*#__PURE__*/_jsx(AttachmentCard, {
      fileAttachments: fileAttachments
    })
  });
};
SpotlightAttachments.displayName = 'SpotlightAttachments';
export default SpotlightAttachments;